import { render, staticRenderFns } from "./head_block.vue?vue&type=template&id=24a70bb2&lang=pug"
import script from "./head_block.vue?vue&type=script&lang=js"
export * from "./head_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports